var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B7A740AB-2CF7-484C-B681-71363CE07AC0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master-Landing-/-Success-Message",
    transform: "translate(-662.000000, -278.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(366.254910, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(296.245090, 119.326938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,0 C9.1958466,0 0,9.1958466 0,20.5 C0,31.8041534 9.1958466,41 20.5,41 C31.8041534,41 41,31.8041534 41,20.5 C41,9.1958466 31.8041534,0 20.5,0 Z",
    id: "Path",
    fill: "#6FB362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6822786,13.1141663 C30.1511044,13.1141663 30.6200022,13.293369 30.9785251,13.6518918 C31.3368848,14.0102516 31.516016,14.4790691 31.516016,14.9479036 C31.516016,15.4167232 31.3368951,15.8856122 30.9785238,16.2441513 L30.9785238,16.2441513 L19.8742541,27.3481081 C19.516736,27.7056263 19.0474205,27.885521 18.578125,27.885521 C18.1088295,27.885521 17.639514,27.7056263 17.2819959,27.3481082 L17.2819959,27.3481082 L11.7300375,21.7961498 C11.3715066,21.4377867 11.1922913,20.9688805 11.1922913,20.5 C11.1922913,20.0311195 11.3715066,19.5622133 11.7299961,19.2038916 C12.0883616,18.8453583 12.5571879,18.6661453 13.0260286,18.6661453 C13.4948544,18.6661453 13.9637522,18.845348 14.3222751,19.2038709 L14.3222751,19.2038709 L18.5781264,23.4597222 L28.3862461,13.6519125 C28.7446116,13.2933792 29.2134379,13.1141663 29.6822786,13.1141663 Z",
    id: "Path",
    stroke: "#FAFAFA",
    strokeWidth: 0.25,
    fill: "#FAFAFA"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.23ea88b1148a456bd6e823ddb358c2a1.svg";
export { ForwardRef as ReactComponent };